import { Typography, TypographyProps } from '@mui/material'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { axiosInstance } from 'service/api/axios'
import { Tooltip } from '../ui/tooltip'

const path = new URL(axiosInstance.defaults.baseURL + '/v1/now/sse')

export const Clock: React.FC<TypographyProps> = props => {
    const clienteTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const [time, setTime] = useState(dayjs().tz(clienteTimezone))

    useEffect(() => {
        const eventSource = new EventSource(path.toString())

        eventSource.onmessage = ({ data }) => {
            const event = JSON.parse(data)

            setTime(dayjs(event.data).tz(clienteTimezone))
        }

        return () => {
            eventSource.close()
        }
    }, [])

    return (
        <Tooltip title="A hora segue o fuso horário da máquina.">
            <Typography variant="body1" {...props}>
                {time.format('L LTS')}
            </Typography>
        </Tooltip>
    )
}
